import { getGVIntlRoutes } from '.'

export const generateTitleAndMetaTags = (title: string, description: string) => {
  return [
    <title key='title'>{title + ' | Gemvision'}</title>,
    <meta key='description' name='description' content={description} />,
    <meta key='og:title' property='og:title' content={title} />,
    <meta key='og:description' property='og:description' content={description} />
  ]
}

export const generateAlternateLinks = (path: string) => {
  const { routeEN, routeES } = getGVIntlRoutes(path)
  return [
    <link key='canonical' rel='canonical' href={routeEN} />,
    <link key='x-default' rel='alternate' hrefLang='x-default' href={routeEN} />,
    <link key='en' rel='alternate' hrefLang='en' href={routeEN} />,
    <link key='es' rel='alternate' hrefLang='es' href={routeES} />
  ]
}
